import { Navigate, Outlet } from "react-router-dom";
import { useLogin } from "@/hooks";

export function LoginCheck() {
  const { isLoggedIn } = useLogin();

  if (isLoggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" replace />;
  }
}
